/* ActionsRenderer.js */

"use strict";

class ActionsColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("actions-column");
        this._rootElem.component = this._model;

        this._deleteIcon = document.createElement("actionable-icon-gl");
        this._deleteIcon.dataset.icon = "common.trash_bin";
        this._deleteIcon.setAttribute("title", "Delete");
        this._editIcon = document.createElement("actionable-icon-gl");
        this._editIcon.dataset.icon = "common.edit";
        this._editIcon.setAttribute("title", "Edit");
        this._viewMoreIcon = document.createElement("actionable-icon-gl");
        this._viewMoreIcon.dataset.icon = "configdrift.view_more";
        this._viewMoreIcon.setAttribute("title", "View Details");

        this._rootElem.appendChild(this._deleteIcon);
        this._rootElem.appendChild(this._editIcon);
        this._rootElem.appendChild(this._viewMoreIcon);

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._deleteIcon.remove();
            this._deleteIcon = undefined;
            this._editIcon.remove();
            this._editIcon = undefined;
            this._viewMoreIcon.remove();
            this._viewMoreIcon = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on("Delete", (this._onDelete = this._onDelete.bind(this)));
        this._model.on("Edit", (this._onEdit = this._onEdit.bind(this)));
        this._model.on("ViewMore", (this._onViewMore = this._onViewMore.bind(this)));
        this._deleteIcon.addEventListener("click", (this._onDeleteIconUserClick = this._onDeleteIconUserClick.bind(this)));
        this._editIcon.addEventListener("click", (this._onEditIconUserClick = this._onEditIconUserClick.bind(this)));
        this._viewMoreIcon.addEventListener("click", (this._onViewMoreIconUserClick = this._onViewMoreIconUserClick.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("Delete");
        this._model.removeAllListeners("Edit");
        this._model.removeAllListeners("ViewMore");
        this._deleteIcon.removeEventListener("click", this._onDeleteIconUserClick);
        this._editIcon.removeEventListener("click", this._onEditIconUserClick);
        this._viewMoreIcon.removeEventListener("click", this._onViewMoreIconUserClick);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setDelete(this._model.getDelete());
            this._setEdit(this._model.getEdit());
            this._setViewMore(this._model.getViewMore());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onDelete(newVal) {
        this._setDelete(newVal);
    }

    _onEdit(newVal) {
        this._setEdit(newVal);
    }

    _onViewMore(newVal) {
        this._setViewMore(newVal);
    }

    _onDeleteIconUserClick() {
        this._model._triggerUserCellAction({
            action: "delete"
        });
    }

    _onEditIconUserClick() {
        this._model._triggerUserCellAction({
            action: "edit"
        });
    }

    _onViewMoreIconUserClick() {
        this._model._triggerUserCellAction({
            action: "viewMore",
            viewDetails: this._model.getViewMore()
        });
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setDelete(newVal) {
        if (newVal === true) {
            this._deleteIcon.classList.remove("hidden");
        } else {
            this._deleteIcon.classList.add("hidden");
        }
    }

    _setEdit(newVal) {
        if (newVal === true) {
            this._editIcon.classList.remove("hidden");
        } else {
            this._editIcon.classList.add("hidden");
        }
    }

    _setViewMore(newVal) {
        if (newVal) {
            this._viewMoreIcon.classList.remove("hidden");
        } else {
            this._viewMoreIcon.classList.add("hidden");
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ActionsColumnRenderer;
